import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { DisabledReq } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";

// 小红书参数加密器
const xsEncrypt = new Xhshow();

export interface searchXhsConnectionsParams extends ActiomCommonParams {
    num: number;
    cursor: string | null;
}

export interface ConnectionsResponse {
    code: number;
    success: boolean;
    msg: string;
    data: ConnectionsDetail;
}

export interface ConnectionsDetail {
    message_list: {
        title: string;
        tag: string;
        tag_type: string;
        id: string;
        type: string;
        user: {
            xsec_token: string;
            userid: string;
            nickname: string;
            images: string;
            fstatus: string;
            red_official_verify_type: number;
        };
        time: number;
        score: number;
        track_type: string;
    }[];
    has_more: boolean;
    strCursor: string;
}

export type PublishAction = CommonAction<searchXhsConnectionsParams, ConnectionsDetail | Record<string, unknown>>;

export const searchXhsWebConnections: PublishAction = async (_task, params) => {
    if (DisabledReq) return response(0, "获取新增关注成功", { message_list: [], has_more: false, strCursor: "" });

    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://www.xiaohongshu.com/",
        origin: "https://www.xiaohongshu.com/",
    };
    const args: AxiosProxyParams = [
        { headers },
        _task.logger,
        params.proxyLoc,
        params.localIP,
        // params.huiwenToken,
        params.accountId,
    ];
    const http = new Http(...args);

    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: {} };

    const connectionsParams = {
        num: params.num ?? 20,
        cursor: params.cursor ?? "",
    };
    const fatchConnections = "/api/sns/web/v1/you/connections";
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});
    const fatchConnectionsXsHeader = xsEncrypt.signHeadersGet(
        fatchConnections,
        recordCookie,
        "xhs-pc-web",
        connectionsParams,
    );

    const res = await http.api<ConnectionsResponse>(
        {
            method: "get",
            url: "https://edith.xiaohongshu.com/api/sns/web/v1/you/connections",
            params: connectionsParams,
            headers: fatchConnectionsXsHeader,
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const isSuccess = res.code === 0;
    const message = `获取新增关注${isSuccess ? "成功" : `失败，原因：${res.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? res.data : {};

    return response(isSuccess ? 0 : 414, message, data);
};
